import { DetailedHTMLProps, FC, HTMLAttributes } from 'react'
import { StyledEllipsisContainer } from './TextWithOverflow.styled'

interface IProps extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  verticalRows?: number
  maxWidth?: string
  title: string
}

export const TextWithOverflow: FC<IProps> = ({ children, verticalRows, maxWidth, title, ...props }) => {
  return (
    <div title={title} {...props}>
      <StyledEllipsisContainer verticalRows={verticalRows} maxWidth={maxWidth}>
        {children}
      </StyledEllipsisContainer>
    </div>
  )
}
